import React, { useCallback, useMemo } from 'react';
import Particles from 'react-tsparticles';
import { loadFull } from 'tsparticles';
const ParticlesBox = ({ children, className, id, settingsFile }) => {
    const rootClassName = useMemo(() => className || 'relative', []);
    const handleParticlesInit = useCallback(async (engine) => {
        await loadFull(engine);
    }, []);
    return (React.createElement("div", { className: rootClassName },
        React.createElement(Particles, { id: id, init: handleParticlesInit, url: settingsFile }),
        React.createElement("div", { className: "relative z-10" }, children)));
};
export default ParticlesBox;
